interface Props {
  id: string;
  title: string;
  images: string[];
}

const ImageGalleryModal: React.FC<Props> = ({ id, title, images }) => {
    const galleryImages =
        images.length > 0 ? images : ["/assets/images/center-img1.webp"];
    return (
        <div
            className="modal fade"
            id={id}
            tabIndex={-1}
            aria-hidden="true"
        >
            <div className="modal-dialog modal-dialog-centered modal-lg imgGallery-modal">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">{title}</h5>
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                        ></button>
                    </div>

                    <div className="modal-body">
                        <div
                            id={`carousel-${id}`}
                            className="carousel slide"
                            data-bs-ride="carousel"
                        >
                            <div className="carousel-inner">
                                {galleryImages.map((img, i) => (
                                    <div
                                        key={i}
                                        className={`carousel-item ${i === 0 ? "active" : ""}`}
                                    >
                                        <div className="imgGalleryHldr">
                                            <img src={img} alt={`img-${i}`} />
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {galleryImages.length > 1 && (
                                <>
                                    <button
                                        className="carousel-control-prev"
                                        type="button"
                                        data-bs-target={`#carousel-${id}`}
                                        data-bs-slide="prev"
                                    >
                                        <span className="carousel-control-prev-icon"></span>
                                    </button>

                                    <button
                                        className="carousel-control-next"
                                        type="button"
                                        data-bs-target={`#carousel-${id}`}
                                        data-bs-slide="next"
                                    >
                                        <span className="carousel-control-next-icon"></span>
                                    </button>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ImageGalleryModal;
